// extracted by mini-css-extract-plugin
export default {"card":"c-e_ei","card_styleDefault":"c-e_ej","card_styleRed":"c-e_ek"};